var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex py-1 pl-1"},[_c('div',[_c('v-icon',{attrs:{"small":"","color":_vm.color}},[_vm._v(_vm._s(_vm.icon))])],1),_c('div',{staticClass:"pl-2"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }